import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material'
import { useState } from 'preact/hooks'
import { api } from '../api/client'
import type { Assignment } from '../api/generated/Assignment'
import { useAction } from '../api/useAction'
import { type AssignedShift, withdrawalOption } from './schedule'

const messages = {
  not_found: "Ce n'est plus possible pour ce créneau.",
}

/** Withdrawing from an accepted shift, or writing to the organizers once it is too late. */
export function Withdraw({
  slug,
  entry,
  deadlineHours,
  onChange,
}: {
  slug: string
  entry: AssignedShift
  deadlineHours: number
  onChange: (assignments: Assignment[]) => void
}) {
  const [confirming, setConfirming] = useState(false)
  const { error, pending, run } = useAction(messages)
  const { assignment } = entry
  const option = withdrawalOption(entry)

  if (option === 'contact')
    return (
      <Stack spacing={0.5} sx={{ alignItems: 'flex-start', my: 1 }}>
        <Typography variant="body2" color="text.secondary">
          Le créneau commence dans moins de {deadlineHours} h : pour vous désister, écrivez aux
          organisateurs.
        </Typography>
        <Button size="small" href={`/events/${slug}/conversations/${assignment.user_id}`}>
          Écrire aux organisateurs
        </Button>
      </Stack>
    )
  if (option !== 'withdraw') return null

  const withdraw = () =>
    run(async () => {
      onChange(
        await api.post<Assignment[]>(`/events/${slug}/assignments/${assignment.id}/withdraw`, {}),
      )
      setConfirming(false)
    })
  return (
    <>
      <Button size="small" color="error" onClick={() => setConfirming(true)}>
        Me désister
      </Button>
      <Dialog open={confirming} onClose={() => setConfirming(false)} maxWidth="xs">
        <DialogTitle>Me désister</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Votre place sera libérée et les organisateurs prévenus.
          </DialogContentText>
          {error && (
            <Alert severity="error" sx={{ mt: 2 }}>
              {error}
            </Alert>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirming(false)}>Annuler</Button>
          <Button color="error" loading={pending} onClick={withdraw}>
            Me désister
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
